import { useLocation, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectAuth } from "../pages/Auth/slice";

export default function ProtectedRoute({ children }) {
  const { token } = useSelector(selectAuth);
  const { pathname } = useLocation();
  const hasToken = token || (typeof localStorage !== "undefined" && localStorage.getItem("token"));

  // 현재 경로가 /cn 계열이면 CN 모드
  const base = pathname.startsWith("/cn") ? "/cn" : "";

  if (!hasToken) {
    return <Navigate to={`${base}/login`} replace />;
  }
  return children;
}
